import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "no-sailing" }
const _hoisted_2 = { class: "no-sailing-title h4" }
const _hoisted_3 = {
  key: 0,
  class: "no-sailing-message"
}
const _hoisted_4 = {
  key: 1,
  class: "no-sailing-message"
}

import { Icon, DictionaryItemWithLink } from '../../Atoms';


export default /*@__PURE__*/_defineComponent({
  __name: 'NoSailingsAvailable',
  props: {
    title: {},
    text1: {},
    text2: {},
    baseUrl: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Icon), {
      "icon-name": "noSailing",
      class: "no-sailing-icon"
    }),
    _createElementVNode("h2", _hoisted_2, _toDisplayString(!_ctx.title ? _ctx.$t('No sailings title') : _ctx.title), 1),
    (_ctx.text1)
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, [
          _createVNode(_unref(DictionaryItemWithLink), {
            text: _ctx.text1,
            "base-url": _ctx.baseUrl
          }, null, 8, ["text", "base-url"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.text2)
      ? (_openBlock(), _createElementBlock("p", _hoisted_4, [
          _createVNode(_unref(DictionaryItemWithLink), {
            text: _ctx.text2,
            "base-url": _ctx.baseUrl
          }, null, 8, ["text", "base-url"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})